// extracted by mini-css-extract-plugin
module.exports = {"block":"block__1mNUO","icon":"icon__1oDlM"};